// Match the transaction policy: layout locks protect their own settings,
// while content-block edit locks also protect their descendants.
export function contentEditorSelectionLocks(editor, selection, profile) {
  const result = { edit: false, move: false, remove: false };
  if (!editor || !selection || profile.mode === 'template') return result;
  const node = selection.node;
  const apply = (candidate, editing = false) => {
    if (!candidate.attrs.lockId) return;
    const lock = candidate.attrs.blockLock || {};
    if (editing) result.edit ||= Boolean(lock.edit);
    result.move ||= Boolean(lock.move);
    result.remove ||= Boolean(lock.remove);
  };
  apply(node, true);
  node.descendants((child) => apply(child));
  const resolved = editor.state.doc.resolve(selection.position);
  for (let depth = 1; depth <= resolved.depth; depth += 1) {
    const parent = resolved.node(depth);
    if (!['container', 'column'].includes(parent.type.name) && parent.attrs.lockId && parent.attrs.blockLock?.edit) {
      result.edit = true;
      result.move = true;
      result.remove = true;
    }
  }
  return result;
}

export function contentEditorTextSelectionLocked(editor, profile) {
  if (!editor || profile.mode === 'template') return false;
  const selection = editor.state.selection;
  const selected = selection.node ? { node: selection.node, position: selection.from } : selection.$from.depth ? { node: selection.$from.parent, position: selection.$from.before(selection.$from.depth) } : null;
  if (contentEditorSelectionLocks(editor, selected, profile).edit) return true;
  let locked = false;
  editor.state.doc.nodesBetween(selection.from, selection.to, (node) => {
    if (!['container', 'column'].includes(node.type.name) && node.attrs.lockId && node.attrs.blockLock?.edit) locked = true;
  });
  return locked;
}

export function contentEditorNodeEditable(editor, node, position, context) {
  if (context?.disabled || !editor?.isEditable || !Number.isInteger(position)) return false;
  if (context?.profile) return !contentEditorSelectionLocks(editor, { node, position }, context.profile).edit;
  return !(node.attrs.lockId && node.attrs.blockLock?.edit);
}
